// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__JcnTg","alertIcon":"ConfirmModal_alertIcon__36GyG"};